import React from 'react'
import Footer from '../components/footer/Footer'
import SoftwareCompanyCta from '../components/software-company-cta/SoftwareCompanyCta'
import FAQ from '../components/Fqas/FAQ'
import TrendsInsights from '../components/trends-n-insights/TrendsInsights'
import NewRoadMap from '../components/new-raodmap-section/NewRoadMap'
import PioneeringChange from '../components/pioneeringChange/PioneeringChange'
import SimpleModels from '../components/simpleEngagementModels'
import CoverTheStack from '../components/coverthestack/CoverTheStack'
import NewCaseStudySection from '../components/new-case-study-section/NewCaseStudySection'
import WhyChooseUs from '../components/why-choose-us/WhyChooseUs'
import NewTestimonials from '../components/new-testimonials/NewTestimonials'
import OurServices from '../components/our-services/OurServices'
import TrustedPartner from '../components/trustedPartners/TrustedPartner'
import ServicesPageBanner from '../components/services-page-banner/ServicesPageBanner'
import MegaHeader from '../components/MegaHeader/MegaHeader'
import { Helmet } from 'react-helmet'
import { computerVisionData } from '../data/computer-vision-page-data'
import { useTranslation } from 'react-i18next'
import tabData from '../data/industryData'
import MegaMenu from '../components/MegaMenu/MegaMenu'

const ComputerVisionDevelopmentServices = () => {

    const { t: stackData } = useTranslation("aiDevelopmentPageContent");
    const coverTheStackData = stackData("aiDevCoverTheStackSection", {
        returnObjects: true,
    });

    return (
        <>
            <Helmet>
                <title>Custom Computer Vision Application Development Services | Bitsclan</title>
                <meta
                    name="description"
                    content="Bitsclan provides expert computer vision development services and custom AI solutions. We have specialized in deep learning and object recognition to help businesses achieve smarter, data-driven results."
                />
            </Helmet>

            <MegaMenu />

            <ServicesPageBanner
                shortHeading={computerVisionData?.bannerContent?.shortHeading}
                mainHeading={computerVisionData?.bannerContent?.mainHeading}
                description={computerVisionData?.bannerContent?.description}
            />

            <TrustedPartner />

            <OurServices
                buttonText="Start Your Computer Vision Project"
                servicesCardsData={computerVisionData?.services?.cardsData}
                shortHeading={computerVisionData?.services?.shortHeading}
                mainHeading={computerVisionData?.services?.heading}
                description={computerVisionData?.services?.description}
            />

            <NewTestimonials
                mainHeading={computerVisionData?.testimonialData?.mainHeading}
                description={computerVisionData?.testimonialData?.description}
                shortHeading={computerVisionData?.testimonialData?.shortHeading}
                content={computerVisionData?.testimonialData?.testimonials}
            />

            <WhyChooseUs
                heading={computerVisionData?.whyUsContent?.heading}
                greenHeading={computerVisionData?.whyUsContent?.greenHeading}
                shortHeading={computerVisionData?.whyUsContent?.shortHeading}
                content={computerVisionData?.whyUsContent?.content}
                stats={computerVisionData?.whyUsContent?.stats}
                cta={computerVisionData?.whyUsContent?.cta}
                sectionImage={computerVisionData?.whyUsContent?.image}
            />

            <NewCaseStudySection
                shortHeading={computerVisionData?.caseStudyContent?.shortHeading}
                heading={computerVisionData?.caseStudyContent?.heading}
                description={computerVisionData?.caseStudyContent?.description}
            />

            <CoverTheStack
                whereStart={"Models & API's"}
                shortHeading={"Our Computer Vision Tech Stack"}
                mainHeading={"Core Technologies Driving Next-Generation Computer Vision"}
                subHeading={
                    "At Bitsclan, we power your DevOps with advanced technologies by delivering efficiency, security, & scalability across the software lifecycle. From AI model development & monitoring to GenAI, compliance, & beyond, our practical stack ensures real-world impact."
                }
                tabs={computerVisionData?.techStack?.tabs}
                tabItems={computerVisionData?.techStack?.tabItems}
            />

            <SimpleModels content={computerVisionData?.engagementModels} />

            <PioneeringChange
                tabData={computerVisionData?.industries?.tabData}
                shortHeading="Industries We Serve"
                greenHeading={"to Real-World Industry Challenges"}
                mainHeading={"Applying Computer Vision "}
                content={
                    "Our computer vision services & solutions create long lasting competitive advantages & support diverse use cases across all major industries."
                }
            />

            {/* <NewRoadMap roadmapContent={computerVisionData?.roadmapContent} /> */}

            <TrendsInsights
                category="ai-developmet"
                heading={computerVisionData?.trendingInsights.heading}
                description={computerVisionData?.trendingInsights.description}
            />

            <FAQ
                faqs={computerVisionData.faqSection.questionAnswers}
                mainHeading={computerVisionData.faqSection.heading}
            />
            <SoftwareCompanyCta content={computerVisionData?.companyCta} />
            <Footer />
        </>
    )
}

export default ComputerVisionDevelopmentServices